export const formatUsername = (username: string | undefined): string => {
  if (username) {
    return username.split('@')[0]
  } else {
    return ''
  }
}
